import { render } from "./icons-twitter.svg?vue&type=template&id=1fa6b8fa?inline"
const script = {}
script.render = render

export default script